/* eslint-disable */

import { useState } from "react";

import { useEffect } from "react";

import OrganisationActivityElement from "../../../ui-components/organisation-activity-element/organisation-activity-element.tsx";

import { fetchGraphQL } from "../../../services/api-raindrop.js";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import { Size } from "../../../logic/enums.ts";

const EditOrganisationActivityElement = ({
  activityId,
  organisationName,
  organisationPresignedUrl,
  createdAt,
  text,
  externalUrl = null,
}) => {
  const [isDeleted, setIsDeleted] = useState(false);

  const onDelete = () => {
    fetchGraphQL(`
      mutation {
        organisationActivityDelete(
          organisationActivityId: "${activityId}"
        ) {
          id
        }
      }
    `).then((response) => {
      if (response.data.organisationActivityDelete.id) {
        setIsDeleted(true);
      } else {
        console.error("Error deleting activity", response);
      }
    });
  };

  if (isDeleted) {
    return null;
  }

  return (
    <div className="flex flex-col  gap-2">
      <div className="w-full">
        <OrganisationActivityElement
          organisationName={organisationName}
          organisationPresignedUrl={organisationPresignedUrl}
          createdAt={createdAt}
          text={text}
          externalUrl={externalUrl}
        />
      </div>
      <div className="flex flex-row gap-2 justify-end">
        <RaindropButton
          title="Edit"
          style={ButtonStyle.Secondary}
          size={Size.Large}
          isUnderConstruction={true}
        />
        <RaindropButton
          title="Delete"
          isDangerous={true}
          style={ButtonStyle.Secondary}
          icon="fa-trash"
          size={Size.Large}
          onClick={onDelete}
        />
      </div>
    </div>
  );
};

const ActivityList = ({ activities }) => {
  if (!activities) {
    return <div>No activities to display</div>;
  }
  return (
    <div className="flex flex-col gap-10 w-full max-w-xl">
      {activities.map((activity) => (
        <EditOrganisationActivityElement
          key={activity.id}
          activityId={activity.id}
          organisationName={activity.organisation.name}
          organisationPresignedUrl={activity.organisation.presignedUrlLogo}
          createdAt={activity.createdAt}
          text={activity.heading}
          externalUrl={activity.externalUrl}
        />
      ))}
    </div>
  );
};

const CirrusActivity = ({}) => {
  const [activities, setActivities] = useState([]);

  useEffect(() => {
    fetchGraphQL(`
      query {
        organisation {
          id
          name
          activityObjects {
            id
            heading
            externalUrl
            createdAt
            organisation {
              presignedUrlLogo
              name
            }
          }
        }
      }
    `).then((response) => {
      setActivities(response.data.organisation?.activityObjects);
    });
  }, []);

  return (
    <div className="flex flex-col gap-4 w-full max-w-xl">
      <h1 className="font-bold text-6xl">Activities</h1>

      <RaindropButton
        title="Create Activity"
        to="/cirrus/activity/new"
        size={Size.Large}
        style={ButtonStyle.Primary}
      />

      <ActivityList activities={activities} />
    </div>
  );
};

export default CirrusActivity;
